import { isValidElement, ReactElement } from "react";
import { FlowPage } from "./FlowPage";
import { AppFlowJSX, FlowPages, PageProps } from "./types";

export const getFlowPages = (node: AppFlowJSX): ReactElement<PageProps>[] => {
  const nodes = Array.isArray(node) ? node : [node];

  return nodes.reduce<FlowPages>((allPages, child) => {
    let pagesAndSubPages: FlowPages = [];

    if (child && child.props.children) {
      pagesAndSubPages = getFlowPages(child.props.children);
    }

    if (isValidElement(child) && child.type === FlowPage) {
      pagesAndSubPages.push(child);
    }

    return [...allPages, ...pagesAndSubPages];
  }, []) as ReactElement<PageProps>[];
};
